import LEGACY_PLANS from "@Constants/legacy-plans";

/**
 * Some custom plans were grandfathered in as "pro" plans, even though they don't have "pro" in the name. This function checks for those legacy plans.
 * E.g. blackfriday's, personal.
 *
 * @param {Object} subscription The subscription object to check.
 * @returns {boolean} True if the subscription is considered a "pro" plan, false otherwise.
 */
export function isConsideredPro(subscription) {
  if (!subscription?.name) {
    return false;
  }

  return LEGACY_PLANS.includes(subscription.name.toLowerCase());
}

/**
 * Determines if a subscription is considered a legacy subscription. A legacy subscription is defined as either being a "pro" plan (including certain grandfathered plans) or a "bulk" plan, excluding any plans that have "-2025" in their name.
 *
 * @param {Object} subscription The subscription object to check.
 * @returns {boolean} True if the subscription is considered a legacy subscription, false otherwise.
 */
export function isSubscriptionLegacy(subscription) {
  if (!subscription?.name) {
    return false;
  }

  return isConsideredPro(subscription) || isSubscriptionLegacyPro(subscription);
}

/**
 * Determines if a subscription is considered a legacy "pro" plan. A legacy "pro" plan is defined as a plan that includes "pro" in its name, excluding any plans that have "-2025" in their name.
 *
 * @param {Object} subscription The subscription object to check.
 * @returns {boolean} True if the subscription is considered a legacy "pro" plan, false otherwise.
 */
export function isSubscriptionLegacyPro(subscription) {
  if (!subscription?.name) {
    return false;
  }

  const name = subscription.name.toLowerCase();

  return name.includes("pro") && !name.includes("-2025");
}

/**
 * Determines if a subscription is considered a legacy "bulk" plan. A legacy "bulk" plan is defined as a plan that includes "bulk" in its name, excluding any plans that have "-2025" in their name.
 *
 * @param {Object} subscription The subscription object to check.
 * @returns {boolean} True if the subscription is considered a legacy "bulk" plan, false otherwise.
 */
export function isSubscriptionLegacyBulk(subscription) {
  if (!subscription?.name) {
    return false;
  }

  const name = subscription.name.toLowerCase();

  return name.includes("bulk") && !name.includes("-2025");
}

export function isSubscriptionNewPro(subscription) {
  if (!subscription?.name) {
    return false;
  }

  const name = subscription.name.toLowerCase();

  return name.includes("pro") && name.includes("-2025");
}

export function isSubscriptionBulk(subscription) {
  if (!subscription?.name) {
    return false;
  }

  const name = subscription.name.toLowerCase();

  return name.includes("bulk");
}
